import React, { Component } from 'react';
import Scroll from 'react-scroll';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import './MobileMenu.css'

var Link       = Scroll.Link;
var Events     = Scroll.Events;
var scrollSpy  = Scroll.scrollSpy;
var scroll     = Scroll.animateScroll;

class MobileMenu extends Component {
  constructor(props) {
    super();
    this.state = {open: false};
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('end');
  }

  componentDidMount() {
    Events.scrollEvent.register('end', function(to, element) {
      // Fractional issue
      if (arguments[0]) {
        scroll.scrollMore(1);
      }
    });

    scrollSpy.update();
  }

  handleToggle = () => {
    this.setState({open: !this.state.open});
  }

  handleClose = () => {
    this.setState({open: false});
  }

  render() {
    return (
      <div>
        <MuiThemeProvider>
          <div>
            <AppBar
              title=""
              style={{position: "fixed", backgroundColor: "rgba(0, 0, 0, .2)"}}
              onLeftIconButtonTouchTap={this.handleToggle}
              iconClassNameRight="muidocs-icon-navigation-expand-more"
            />
            <Drawer docked={false} width={200} open={this.state.open}>
              <MenuItem onTouchTap={this.handleClose} >
                <Link activeClass="active" to="when" spy={true} smooth={true} offset={0} duration={500}>When</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="venue" spy={true} smooth={true} offset={0} duration={500}>Venue</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="story" spy={true} smooth={true} offset={0} duration={500}>Our Story</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="registry" spy={true} smooth={true} offset={0} duration={500}>Registry</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="where-to-stay" spy={true} smooth={true} offset={0} duration={500}>Where to Stay</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="what-to-do" spy={true} smooth={true} offset={0} duration={500}>What to Do</Link>
              </MenuItem>
              <MenuItem onTouchTap={this.handleClose}>
                <Link activeClass="active" to="wedding-day-faqs" spy={true} smooth={true} offset={0} duration={500}>Wedding Day FAQs</Link>
              </MenuItem>
              {this.props.loggedIn ? (
                <MenuItem>
                  <a className="rsvp-link" href="/photos">Photos</a>
                </MenuItem>
              ) : ""}
              {this.props.loggedIn ? (
                <MenuItem>
                  <a className="rsvp-link" href="/rsvp">RSVP</a>
                </MenuItem>
              ) : ""}
            </Drawer>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/MobileMenu.js